import moment from "moment";
import { divConfig, markConfig, quantityConfig, rateConfig } from "./constants";
import _ from "lodash";

export const validateQuantity = (quantity: any) => {
  return (
    (quantity &&
      quantity % 1 === 0 &&
      quantity >= quantityConfig.min &&
      quantity < quantityConfig.max) === true
  );
};

export const validateRate = (rate: any) => {
  return /^-?(\d{1,3}|\d{1,3}\.\d{1,4})$/.test(rate);
};

export const validateCpty = (cpty: string) => {
  return cpty ? true : false;
};

export const validateTicker = (ticker: any) => {
  return ticker && !_.isEmpty(ticker);
};

export const validateMark = (mark: number) => {
  return (mark && mark > 0) === true;
};

export const validateValue = (value: number) => {
  return value > 0;
};

export const validateC_N = (c_n: string) => {
  return (
    (c_n && (c_n.toLowerCase() === "c" || c_n.toLowerCase() === "n")) === true
  );
};

export const validateDiv = (div: string) => {
  return (
    (div && parseInt(div) > divConfig.min && parseInt(div) < divConfig.max) ===
    true
  );
};

export const validateProfitCenter = (pc: string) => {
  return (
    (pc && pc?.length === 1 && /[A-Z0-9 !@#$%&*()+=?]/gm.test(pc)) === true
  );
};

export const validateTermDate = (date: any) => {
  let now = moment();
  return (date && (now.isSame(date, "day") || now.isBefore(date))) === true;
};

export const validateBorrowAndLoan = (bl: string) => {
  return (bl && bl?.length === 1) === true;
};
